import { VizionEmbedUrlAction } from './actions'
import { ActionTypes, VizionEmbedUrlState } from './types'

const initialState: VizionEmbedUrlState = {
  embedurl: null,
  loading: false,
  error: null,
}

const vizionEmbedUrlReducer = (
  state = initialState,
  action: VizionEmbedUrlAction,
): VizionEmbedUrlState => {
  switch (action.type) {
    case ActionTypes.REQUEST_VIZION_EMBED_URL:
      return {
        ...state,
        loading: true,
        embedurl: null,
        error: null,
      }
    case ActionTypes.SUCCESS_VIZION_EMBED_URL:
      return {
        ...state,
        loading: false,
        embedurl: action.payload.embedurl,
        error: null,
      }
    case ActionTypes.ERROR_VIZION_EMBED_URL:
      return {
        ...state,
        loading: false,
        embedurl: null,
        error: action.payload.error,
      }
    default:
      return state
  }
}

export default vizionEmbedUrlReducer
